import React, { ReactNode } from 'react';
import { motion } from 'framer-motion';
import Box from '@mui/material/Box';

interface AnimatedBackgroundBoxProps {
    backgroundImage: string;
    position: string;
    size: string;
    children?: ReactNode;
}

const AnimatedBackgroundBox: React.FC<AnimatedBackgroundBoxProps> = ({
                                                                         backgroundImage,
                                                                         position,
                                                                         size,
                                                                         children
                                                                     }) => {
    return (
        <Box
            component={motion.div}
            initial={{
                scale: 1.1,
                opacity: 0
            }}
            animate={{
                scale: 1,
                opacity: 1
            }}
            transition={{
                duration: 4,
                ease: [0.4, 0, 0.2, 1],
                opacity: {
                    duration: 1.2,
                    ease: "easeInOut"
                },
                scale: {
                    duration: 1.5,
                    ease: [0.4, 0, 0.2, 1]
                }
            }}
            sx={{
                position: 'relative',
                height: {
                    xs: '45vh',
                    md: '65vh'
                },
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.1)), url(${backgroundImage})`,
                backgroundSize: {
                    xs: `${size}`,
                    md: 'cover'
                },
                backgroundRepeat: 'no-repeat',
                backgroundPosition: {
                    xs: 'top',
                    md: `${position}`
                },
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: '#fff',
                textAlign: 'center',
                backgroundAttachment: 'fixed',
                willChange: 'transform',
                transform: 'translateZ(0)',
                '&::after': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    pointerEvents: 'none'
                }
            }}
        >
            {children}
        </Box>
    );
};

export default AnimatedBackgroundBox;